import moment from 'moment'

// fill this api keys for Playground display WMS requests
// const SENTINEL_1 = 'e9ee54a8-9fba-4c4c-9bb5-be7463ee28a0'
// const SENTINEL_2_L2A = '4c0a2195-be2e-4c2e-b39b-84237752c905'
// const SENTINEL_2_L1C = 'ef181763-3770-4ceb-9755-0a8d25703c96'
// const SENTINEL_3 = '2a72384b-69c5-446d-ad4b-f4bb29cec2ba'
// const SENTINEL_5 = 'd72c9d9f-87bb-455d-9dd4-f68eb1f2c5c4'

const SENTINEL_1 = '4cdd0ec5-3437-4515-8805-64cea6f9173e'
const SENTINEL_2_L2A = '443891d9-6744-40f8-a832-56227d581205'
const SENTINEL_2_L1C = '4601c6d1-0af6-4bd4-be7b-06325918c732'
const SENTINEL_3 = '30b191ab-1ac9-4181-89fe-6fecca5c3750'
const SENTINEL_5 = '76aca887-14ac-40b3-ba67-478d2096ffea'

const LANDSAT_8_API_KEY = '' //'d1951594-daea-42dc-8d51-203014edc660'
const DEM_API_KEY = ''
const MODIS_API_KEY = ''//'eb44b4ab-f98b-4511-824f-c5068e04a8a3'
const WILDFIRES = 'ba455c71-5a0e-4124-a0fc-3a981c6cf65f'
const FLOODING = 'e69541cf-65a0-4037-a684-69b857e1b152'

const DATASOURCES = [
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L2A}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L2A}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2017-03-28',
    id: 'DSS2',
    datasourceID: 'S2L2A',
    name: 'Sentinel-2 L2A',
    typeNames: 'DSS2',
    min: 9
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L1C}`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L1C}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L1C/searchIndex',
    minDate: '2015-01-01',
    id: 'S2.TILE',
    datasourceID: 'S2L1C',
    name: 'Sentinel-2 L1C',
    typeNames: 'S2.TILE'
  },
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_1}`,
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1',
    name: 'Sentinel-1'
  },
  {
    url: `https://creodias.sentinel-hub.com/ogc/wms/${SENTINEL_3}`,
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S3',
    name: 'Sentinel-3'
  },
  {
    url: `https://creodias.sentinel-hub.com/ogc/wms/${SENTINEL_5}`,
    index: 'https://creodias.sentinel-hub.com/index/v3/collections/S5PL2/searchIndex',
    minDate: '2020-01-01',
    id: 'S5',
    name: 'Sentinel-5P'
  },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${LANDSAT_8_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/L8L1C/searchIndex',
  //   minDate: '2013-01-01',
  //   id: 'L8',
  //   datasourceID: 'L8L1C',
  //   name: 'Landsat 8',
  //   min: 10,
  //   typeNames: 'DSS6'
  // },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${DEM_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/DEM/searchIndex',
  //   minDate: '2013-01-01',
  //   id: 'DEM',
  //   name: 'DEM',
  //   datasourceID: 'DEM',
  //   min: 2,
  //   typeNames: 'DSS4'
  // },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${MODIS_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/modis/v2/',
  //   minDate: '2013-01-01',
  //   id: 'Modis',
  //   noEffects: true,
  //   name: 'MODIS',
  //   datasourceID: 'MODIS',
  //   min: 7,
  //   typeNames: 'DSS5'
  // },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
  //   urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
  //   index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
  //   minDate: '2017-03-28',
  //   id: 'FLOODING',
  //   datasourceID: 'S2L2A',
  //   name: 'FLOODING',
  //   typeNames: 'DSS2',
  //   min: 9
  // },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
  //   urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
  //   index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
  //   minDate: '2017-03-28',
  //   id: 'WILDFIRES',
  //   datasourceID: 'S2L2A',
  //   name: 'WILDFIRES',
  //   typeNames: 'DSS2',
  //   min: 9
  // }
]
const datasources = DATASOURCES,
  customPreset = {
    CUSTOM: {
      name: 'Custom',
      desc: 'Create custom rendering',
      image: 'image.jpg'
    }
  },
  VIEWS = {
    PRESETS: '1',
    BANDS: '2',
    SCRIPT: '3'
  }

export default {
  noCredentials: SENTINEL_2_L1C === '' && LANDSAT_8_API_KEY === '' && MODIS_API_KEY === '',
  customPreset,
  layers: {
    r: 'B04',
    g: 'B03',
    b: 'B02'
  },
  activeDatasource: {...DATASOURCES[0]},
  startLocation: '',
  doRefresh: true,
  activeBaseLayer: {
    name: '',
    minmax: { min: 0, max: 16 }
  },
  evalscripturl: '',
  isLoaded: true,
  lat: 40.6400955,
  lng: 22.9443976,
  zoom: 12,
  size: [0, 0],
  priority: 'mostRecent',
  mosaic: 'mostRecent',
  evalscript: '',
  renderedEvalscript: '',
  opacity: 100,
  maxcc: 20,
  imgWmsUrl: '',
  mapBounds: {},
  minDate: '2015-01-01',
  maxDate: moment(),
  selectedDate: moment().add(-1,'days'),
  dateFormat: 'YYYY-MM-DD',
  availableDays: [],
  datesCcMap: {},
  onDayPicked: false,
  prevDate: null,
  nextDate: null,
  showDates: false,
  preset: null,
  currView: VIEWS.PRESETS,
  channels: [],
  path: '',
  presets: {
    customPreset
  },
  presetsLegend: [],
  atmFilter: '',
  cloudCorrection: 'none',
  gain: new Number(1).toFixed(1),
  gamma: new Number(1).toFixed(1),
  legendVisible: false,
  devMode: false,
  selectedDevToolsTab: 1,
  devModalVisible: false,
  legendX: 0,
  legendY: 0,
  legendHeight: 0,
  legendWidth: 0,
  legendUrl: null,
  views: VIEWS,
  datasources
}



// WEBPACK FOOTER //
// ./src/store/config.js